import React from 'react'
// libs
import { reduxForm } from 'redux-form'
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client/react'
// graphql
import { COMPANY_UPDATE_MUTATION } from 'graphql/company/mutations'
// components
import BottomPaper from '../BottomPaper'
import { ReduxInput, ReduxSwitch } from 'components/FormElements'
// store
import { setAccumulatedFormData } from 'store/reducers/accumulatedForms'
// constants
import { Forms } from 'constants/index'
// themes
import { Form } from 'themes/views/settings'
// views
import { FieldsContainer } from './views'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// utils
import { minValue300 } from 'utils/validators'

interface Props {
  goNextTab: () => void
  prepareForApi: (data?: any) => any
  handleCancelClick: () => void
}

const SecurityForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  goNextTab,
  handleSubmit,
  prepareForApi,
  handleCancelClick
}) => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [companyUpdateMutation] = useMutation(COMPANY_UPDATE_MUTATION)

  const handleFormSubmit = async (data) => {
    const isUpdate = !!router.query.id

    if (isUpdate) {
      try {
        await companyUpdateMutation({
          variables: {
            id: router.query.id,
            company: prepareForApi(data)
          }
        })

        handleCancelClick()
      } catch (errors) {
        console.error('[SecurityForm.handleFormSubmit]: ', errors)
      }
    } else {
      dispatch(
        setAccumulatedFormData({
          type: Forms.ACCUMULATED_CREATE_ACCOUNT,
          data
        })
      )
      goNextTab()
    }
  }

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <FieldsContainer>
        <ReduxSwitch name='twoFactorEnforced' label='Enforce Two-Factor Authentication' />
        <ReduxInput
          type='number'
          validate={minValue300}
          name='refreshTokenAbsoluteTtl'
          label='Refresh Token Absolute TTL (seconds)'
        />
        <ReduxInput label='Idle Timeout (seconds)' name='idleTimeoutSeconds' type='number' validate={minValue300} />
      </FieldsContainer>
      <BottomPaper onCancelClick={handleCancelClick} />
    </Form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.ACCOUNT_SECURITY_FORM,
  destroyOnUnmount: true,
  enableReinitialize: true
})(SecurityForm)
